import React, { useMemo } from 'react';
import { passwordRequirements } from 'utils/schema';

const PasswordRequirements = ({
  password,
  confirmation,
  email,
  username,
  currentPassword,
}) => {
  const requirements = useMemo(() => {
    const { schemas } = passwordRequirements({
      email,
      username,
      confirmation,
      currentPassword,
    });

    return schemas.map(({ name, message, schema }) => ({
      name,
      message,
      ok: password && schema.isValidSync(password),
    }));
  }, [email, username, confirmation, currentPassword, password]);

  return (
    <ul className="list-unstyled">
      {requirements.map(({ name, message, ok }) => (
        <li key={name}>
          <i
            className={
              ok
                ? 'far fa-check-circle text-success'
                : 'far fa-times-circle text-danger'
            }
          />{' '}
          <span>{message}</span>
        </li>
      ))}
    </ul>
  );
};

export default PasswordRequirements;
